import React from 'react';
import FadeInImage from 'components/FadeInImage';
import { GenericButton } from 'components/GenericButton';
import './style.scss';

export const CustomAlert = ({
  text,
  title,
  asset,
  onClose,
  textButton,
  containerClassNames = [''],
}) => {
  return (
    <div className={['cv-custom-alert', ...containerClassNames].join(' ')}>
      <div className="cv-custom-alert__dialog">
        <FadeInImage
          imageAlt="cv-asset"
          imageSrc={asset}
          classNames={['cv-custom-alert__dialog__asset']}
          width={44}
          height={40}
        />
        <div className="cv-custom-alert__dialog__title">{title}</div>
        {text && <div className="cv-custom-alert__dialog__text">{text}</div>}
        <GenericButton
          textContent={textButton}
          classNames={['cv-custom-alert__dialog__button']}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default CustomAlert;
